module.exports = __webpack_public_path__ + "img/yonghu.49f32944.png";